<app-loader [ShowLoader]="restaurantOrderMode && isRestaurantOrderDetailLoading"></app-loader>
<div class="backdrop" (click)="onOrderToggleClick()"></div>
<div class="manage-restaurant-guest-wrapper custom-scrollbar">
    <div class="restaurant-guest-header">
        <div class="restaurant-guest-detail-wrapper d-flex">
            <div class="restaurant-guest-detail d-flex">
                <div class="d-flex align-items-center guest-name-row">
                    <h2
                        class="guest-name"
                        [class.guest-name--empty]="restaurantOrderMode && !isEditingGuestName && !orderDetails?.guestName">
                        <ng-container *ngIf="!isEditingGuestName">
                            <span>{{ orderDetails?.guestName || (restaurantOrderMode ? ('Add guest name' | translate) : '') }}</span><button
                                *ngIf="canEditGuestName"
                                type="button"
                                class="guest-edit-button pointer"
                                [appAccessCheck]="'Manage-Restaurant-Orders'"
                                [givenButton]="'manage'"
                                (click)="startEditGuestName()"
                                [matTooltip]="'Edit guest name' | translate"
                                [attr.aria-label]="'Edit guest name' | translate"><i class="material-icons" aria-hidden="true">edit</i></button>
                        </ng-container>

                        <input
                            *ngIf="isEditingGuestName"
                            #guestNameInput
                            class="guest-name-input"
                            type="text"
                            maxlength="80"
                            autocomplete="off"
                            placeholder="{{ 'Guest name' | translate }}"
                            [(ngModel)]="guestNameDraft"
                            (keyup.enter)="saveGuestName()"
                            (keyup.escape)="cancelEditGuestName()"
                            (blur)="saveGuestName()"
                            [attr.aria-label]="'Guest name' | translate" />
                    </h2>
                    <mat-chip *ngIf="!restaurantOrderMode" class="guest-chip nunito font-12">Restaurant Guest</mat-chip>
                </div>

                <span class="nunito guest-phone-number" *ngIf="!restaurantOrderMode || orderDetails?.PhoneNumber">Phone No. : <strong>{{this.orderDetails?.countryCode}} {{this.orderDetails?.PhoneNumber}}</strong></span>
            </div>
            <svg (click)='onOrderToggleClick()' class="restro-cancel pointer" width="20" height="20" viewBox="0 0 20 20" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.3125 2.5625L11.875 10L19.3125 17.4375L17.4375 19.3125L10 11.875L2.5625 19.3125L0.6875 17.4375L8.125 10L0.6875 2.5625L2.5625 0.6875L10 8.125L17.4375 0.6875L19.3125 2.5625Z"
                    fill="black" />
            </svg>


        </div>

        <div class="restuarant-assignee-details-wrapper d-flex flex-wrap">
            <ng-container *ngIf="restaurantOrderMode; else legacyAssistedStaff">
                <p *ngIf="staffName" class="asigned-detail nunito">Staff: <strong>{{ staffName }}</strong></p>
            </ng-container>
            <ng-template #legacyAssistedStaff>
                <p class="asigned-detail nunito">Assisted Staff :
                    <ng-container *ngFor="let staff of orderDetails?.AssignedStaffNames; let last = last">
                        <strong>{{ staff? staff :'Not Assigned' }}{{ !last ? ', ' : '' }}</strong>
                    </ng-container>

                </p>
            </ng-template>
            <p class="asigned-detail nunito">{{'Order ID'|translate}} <strong>{{this.orderDetails?.orderId}}</strong></p>
            <p class="asigned-detail nunito">{{'Order no.'|translate}} <strong>{{this.orderDetails?.orderNo}}</strong></p>
            <p class="asigned-detail nunito">{{this.orderDetails?.tableNumber?'Table no.':'Room no.'}} : <strong>{{this.orderDetails?.tableNumber?this.orderDetails?.tableNumber:this.orderDetails?.roomNumber}}</strong></p>
        </div>

    </div>

    <div class="restaurant-guest-history-wrapper">
        <mat-tab-group class="guest-order-history-wrapper" [class.single-order-tab]="restaurantOrderMode">

            <mat-tab label="Current Order" class="current-order-tab nunito">
                <!-- Inclusive mode: grouped by category -->
                <ng-container *ngIf="isInclusive && groupedDataSource.length > 0">
                    <div *ngFor="let group of groupedDataSource" class="inclusive-category-group">
                        <h4 class="nunito inclusive-category-title">{{ group.categoryName }}</h4>
                        <div class="inventory-table-wrapper">
                            <div class="inventory-table">
                                <table mat-table [dataSource]="group.items" class="mat-elevation-z8">
                                    <ng-container matColumnDef="position">
                                        <th mat-header-cell *matHeaderCellDef>Item Name</th>
                                        <td mat-cell *matCellDef="let element"><span class="mob-header-text">Item Name:</span> {{element.Itemname}}</td>
                                    </ng-container>
                                    <ng-container matColumnDef="name">
                                        <th mat-header-cell *matHeaderCellDef class="d-flex align-items-center">Price<span class="secondary-text ml-5" [innerHTML]="currencyLogo!=null?currencyLogo:currencyAbri"></span></th>
                                        <td mat-cell *matCellDef="let element"><span class="mob-header-text">Price:</span> {{element.Price}}</td>
                                    </ng-container>
                                    <ng-container matColumnDef="weight">
                                        <th mat-header-cell *matHeaderCellDef>Quantity</th>
                                        <td mat-cell *matCellDef="let element"><span class="mob-header-text">Quantity:</span> {{element.Quantity}}</td>
                                    </ng-container>
                                    <ng-container matColumnDef="symbol">
                                        <th mat-header-cell *matHeaderCellDef class="d-flex align-items-center">Amount<span class="secondary-text ml-5" [innerHTML]="currencyLogo!=null?currencyLogo:currencyAbri"></span></th>
                                        <td mat-cell *matCellDef="let element"><span class="mob-header-text">Amount:</span> {{element.Amount}}</td>
                                    </ng-container>
                                    <ng-container matColumnDef="itemComment">
                                        <th mat-header-cell *matHeaderCellDef>Comment</th>
                                        <td mat-cell *matCellDef="let element" class="item-comment-cell">
                                            <span class="mob-header-text">Comment:</span>
                                            <button
                                                type="button"
                                                class="item-comment-button pointer"
                                                [class.has-comment]="!!element.staffMealComment"
                                                (click)="openItemComment(element)"
                                                [matTooltip]="(element.staffMealComment ? 'View or edit comment' : 'Add comment') | translate"
                                                [attr.aria-label]="(element.staffMealComment ? 'View or edit comment' : 'Add comment') | translate">
                                                <i class="material-icons" aria-hidden="true">{{ element.staffMealComment ? 'chat' : 'add_comment' }}</i>
                                            </button>
                                        </td>
                                    </ng-container>
                                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </ng-container>

                <!-- Standard flat view (non-inclusive mode) -->
                <ng-container *ngIf="!isInclusive">
                    <div class="inventory-table-wrapper order-bill">
                        <div class="inventory-table">
                            <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

                                <!--- Note that these columns can be defined in any order.
                                      The actual rendered columns are set as a property on the row definition" -->

                                <!-- Position Column -->
                                <ng-container matColumnDef="position">
                                    <th mat-header-cell *matHeaderCellDef>Item Name </th>
                                    <td mat-cell *matCellDef="let element"><span class="mob-header-text">Item Name:</span> {{element.Itemname}} </td>
                                </ng-container>

                                <!-- Name Column -->
                                <ng-container matColumnDef="name">
                                    <th mat-header-cell *matHeaderCellDef class="d-flex align-items-center"> Price<span class="secondary-text ml-5"
                                        [innerHTML]="currencyLogo!=null?currencyLogo:currencyAbri"></span> </th>
                                    <td mat-cell *matCellDef="let element"><span class="mob-header-text">Price:</span> {{element.Price}} </td>
                                </ng-container>

                                <!-- Weight Column -->
                                <ng-container matColumnDef="weight">
                                    <th mat-header-cell *matHeaderCellDef> Quantity </th>
                                    <td mat-cell *matCellDef="let element"><span class="mob-header-text">Quantity:</span> {{element.Quantity}} </td>
                                </ng-container>

                                <!-- Symbol Column -->
                                <ng-container matColumnDef="symbol">
                                    <th mat-header-cell *matHeaderCellDef class="d-flex align-items-center"> Amount <span class="secondary-text ml-5"
                                        [innerHTML]="currencyLogo!=null?currencyLogo:currencyAbri"></span> </th>
                                    <td mat-cell *matCellDef="let element"><span class="mob-header-text">Amount:</span> {{element.Amount}} </td>
                                </ng-container>

                                <ng-container matColumnDef="itemComment">
                                    <th mat-header-cell *matHeaderCellDef> Comment </th>
                                    <td mat-cell *matCellDef="let element" class="item-comment-cell">
                                        <span class="mob-header-text">Comment:</span>
                                        <button
                                            type="button"
                                            class="item-comment-button pointer"
                                            [class.has-comment]="!!element.staffMealComment"
                                            (click)="openItemComment(element)"
                                            [matTooltip]="(element.staffMealComment ? 'View or edit comment' : 'Add comment') | translate"
                                            [attr.aria-label]="(element.staffMealComment ? 'View or edit comment' : 'Add comment') | translate">
                                            <i class="material-icons" aria-hidden="true">{{ element.staffMealComment ? 'chat' : 'add_comment' }}</i>
                                        </button>
                                    </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                            </table>
                        </div>
                    </div>
                </ng-container>

                <div class="order-add-actions" *ngIf="canAddItems">
                    <button
                        type="button"
                        class="invoice-button pointer"
                        [appAccessCheck]="'Manage-Restaurant-Orders'"
                        [givenButton]="'manage'"
                        (click)="addMoreItems()">
                        {{ 'Add items' | translate }}
                    </button>
                </div>

                <div class="billing-amount d-flex mt-24 nunito">
                    <div class="subtotal d-flex align-items-center justify-content-between nunito font-14 fw-500">
                        <span>{{ 'restaurantSplitBill.netAmount' | translate }}</span>
                        <span class="d-flex align-items-center"><span class="secondary-text ml-5 currency-prefix"
                            [innerHTML]="currencyLogo!=null?currencyLogo:currencyAbri"></span>{{priceWithoutTax?.toFixed(2)}}</span>
                    </div>
                    <div class="subtotal d-flex align-items-center justify-content-between nunito font-14 fw-500">
                        <span>{{ 'restaurantSplitBill.taxAmount' | translate }} {{formattedTaxRates}}</span>
                        <span class="d-flex align-items-center"><span class="secondary-text ml-5 currency-prefix"
                            [innerHTML]="currencyLogo!=null?currencyLogo:currencyAbri"></span>{{this.tax?this.tax?.toFixed(2):'0.00'}}</span>
                    </div>
                    <div
                        class="subtotal billing-tip-row d-flex align-items-center justify-content-between nunito font-14 fw-500"
                        [class.billing-tip-row--editable]="canEditTip">
                        <span>{{ 'restaurantSplitBill.tip' | translate }}</span>
                        <div class="restaurant-order-tip-editor" *ngIf="canEditTip">
                            <div class="tip-choice-group">
                                <button
                                    *ngFor="let amount of restaurantOrderTipOptions"
                                    type="button"
                                    class="tip-option pointer"
                                    [class.is-selected]="!showCustomTip && orderTip === amount"
                                    [attr.aria-pressed]="!showCustomTip && orderTip === amount"
                                    (click)="selectTip(amount)">
                                    {{ amount }}
                                </button>
                                <button
                                    *ngIf="!showCustomTip"
                                    type="button"
                                    class="tip-option tip-option--custom pointer"
                                    [class.is-selected]="customTipSelected"
                                    [attr.aria-pressed]="customTipSelected"
                                    (click)="openCustomTip()">
                                    {{ 'restaurantOrderActions.customAmount' | translate }}
                                </button>
                                <div class="inline-custom-tip" *ngIf="showCustomTip">
                                    <span class="currency-prefix" [innerHTML]="currencyLogo!=null?currencyLogo:currencyAbri"></span>
                                    <input
                                        type="number"
                                        min="0"
                                        step="0.01"
                                        inputmode="decimal"
                                        [ngModel]="customTipAmount"
                                        (ngModelChange)="onCustomTipChange($event)"
                                        (keydown.enter)="applyCustomTip()"
                                        [attr.aria-label]="'restaurantOrderActions.customAmount' | translate" />
                                    <button type="button" class="inline-custom-tip__apply pointer" [disabled]="!canApplyCustomTip" (click)="applyCustomTip()">
                                        <mat-icon>check</mat-icon>
                                    </button>
                                    <button type="button" class="inline-custom-tip__cancel pointer" (click)="cancelCustomTip()">
                                        <mat-icon>close</mat-icon>
                                    </button>
                                </div>
                            </div>
                            <span class="restaurant-order-tip-editor__error" role="alert" *ngIf="tipErrorMessage">
                                {{ tipErrorMessage }}
                            </span>
                        </div>
                        <ng-container *ngIf="restaurantOrderMode; else legacyTipAmount">
                            <span class="billing-tip-row__amount d-flex align-items-center"><span class="secondary-text ml-5 currency-prefix"
                                [innerHTML]="currencyLogo!=null?currencyLogo:currencyAbri"></span>{{orderTip?.toFixed(2)}}</span>
                        </ng-container>
                        <ng-template #legacyTipAmount>
                            <span class="d-flex align-items-center"><span class="secondary-text ml-5 currency-prefix"
                                [innerHTML]="currencyLogo!=null?currencyLogo:currencyAbri"></span>{{(this.orderDetails?.tip)?.toFixed(2)}}</span>
                        </ng-template>
                    </div>
                    <div class="subtotal d-flex align-items-center justify-content-between nunito font-18 fw-700">
                        <strong>{{ 'restaurantSplitBill.totalDue' | translate }}</strong>
                        <span class="d-flex align-items-center"> <span class="secondary-text ml-5 currency-prefix"
                            [innerHTML]="currencyLogo!=null?currencyLogo:currencyAbri"></span>{{orderTotalDue?.toFixed(2)}}</span>
                    </div>
                    <div class="subtotal d-flex align-items-center justify-content-between nunito font-18 fw-700" *ngIf="isInclusive && inclusiveDisplayAmount !== null">
                        <strong>Inclusive Total (Lunch + Dinner)</strong>
                        <span class="d-flex align-items-center"> <span class="secondary-text ml-5 currency-prefix"
                            [innerHTML]="currencyLogo!=null?currencyLogo:currencyAbri"></span>{{inclusiveDisplayAmount?.toFixed(2)}}</span>
                    </div>
                </div>

                <div
                    class="d-flex printing-button"
                    [class.restaurant-order-payment-footer]="restaurantOrderMode">
                    <p class="nunito font-14" *ngIf="!restaurantOrderMode">Additional request :<strong>{{this.orderDetails?.Message?this.orderDetails?.Message:"NA"}}</strong></p>

                    <ng-container *ngIf="restaurantOrderMode; else legacyInvoiceActions">
                        <div
                            *ngIf="canUpdateOrderPaymentStatus"
                            class="restaurant-order-actions nunito">
                            <span
                                class="restaurant-order-split-progress"
                                *ngIf="!isOrderPaid && orderDetails?.BillSplitSummary as splitSummary">
                                {{ 'restaurantSplitBill.paymentProgress' | translate: {
                                    paid: splitSummary.paidInvoiceCount,
                                    count: splitSummary.invoiceCount
                                } }}
                            </span>
                            <button
                                *ngIf="!isOrderPaid || hasActiveBillSplit; else paidRestaurantOrder"
                                type="button"
                                class="invoice-button restaurant-order-payment-button pointer"
                                [appAccessCheck]="'Manage-Restaurant-Orders'"
                                [givenButton]="'manage'"
                                [disabled]="isUpdatingTip"
                                (click)="openSettleBillDialog()">
                                {{ settleBillButtonLabel | translate }}
                            </button>

                            <ng-template #paidRestaurantOrder>
                                <div class="restaurant-order-paid-state" role="status">
                                    <span class="restaurant-order-paid-label">
                                        <span class="restaurant-order-paid-check" aria-hidden="true">&#10003;</span>
                                        {{ 'restaurantSplitBill.paymentReceived' | translate }}
                                    </span>
                                </div>
                            </ng-template>
                        </div>
                    </ng-container>

                    <ng-template #legacyInvoiceActions>
                        <div>
                            <button class="print-button pointer" (click)="printOrder(this.orderDetails._id,true)">Print</button>
                            <button class="invoice-button pointer ml-2" (click)="openInvoice()">Download Invoice</button>
                            <button class="invoice-button pointer ml-2" (click)="printInvoice()">Print Invoice</button>
                        </div>
                    </ng-template>
                </div>

            </mat-tab>


            <mat-tab *ngIf="!restaurantOrderMode" label="Order History" (click)="OrderHistory()">


                <div class="previous-tab-header-wrapper">
                    <div class="d-flex align-items-center justify-content-between">
                        <span class="tab-text nunito">Last 5 Orders</span>
                        <app-calender-filter class="restaurant-calender" (cancelClicked)="hideCalendarFilter()" (dateSelected)="selectdDateFilter($event)"></app-calender-filter>
                    </div>

                </div>

                <div class="restro-guest-assignee-wrapper"*ngFor="let order of RestaurantOrder ; let i = index">
                    <div class="restro-guest-assignee">
                        <div class="restro-guest">
                            <strong class="nunito guest-assignee-label">Date</strong>
                            <span class="nunito guest-assignee-text">{{ order.CreatedAt| date:'dd MMM, hh:mm a' }}</span>
                        </div>
                        <div class="restro-guest">
                            <strong class="nunito guest-assignee-label">Restaurant Name</strong>
                            <span class="nunito guest-assignee-text">{{ order.ResturantName?order.ResturantName[0].Value:'' }}</span>
                        </div>
                        <div class="restro-guest">
                            <strong class="nunito guest-assignee-label">Payment Status</strong>
                            <span ngClass="{{order.PaymentStatus === 1 ?'order-status-guest d-flex align-items-center mtop-5 nunito font-14':'order-status-guest-status d-flex align-items-center mtop-5 nunito font-14 '}}">{{ order.PaymentStatus === 1 ? 'Paid' : 'Unpaid' }}</span>
                        </div>
                        <div class="restro-guest">
                            <strong class="nunito guest-assignee-label">Assigned Staff</strong>
                            <ng-container *ngFor="let staff of order.AssignedStaffNames; let last = last">
                                <span class="mtop-5 nunito font-14">{{ staff? staff :'Not Assigned' }}{{ !last ? ', ' : '' }}</span>
                            </ng-container>
                        </div>
                    </div>
                    
                    <mat-accordion class="restro-guest-accordion">
                        <mat-expansion-panel class="restro-guest-expansion" (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                            <mat-expansion-panel-header class="restro-guest-expansion-header">
                                <mat-panel-title class="restro-guest-expansion-title">
                                    <span class="nunito view-mode">View {{ panelOpenState ? 'less' : 'more' }} </span>
                                  </mat-panel-title>
                                <mat-panel-description>
                                    <div class="restro-guest">
                                        <strong class="nunito guest-assignee-label">Order ID</strong>
                                        <span class="nunito guest-assignee-text">{{order.orderId}}</span>
                                    </div>
                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <span class="guest-restro-label nunito">Order Details</span>

                            <div class="inventory-table-wrapper">
                               
                                    <div class="inventory-table custom-scrollbar">
                                        <div class="example-container mat-elevation-z8 custom-scrollbar">
                                            <table mat-table [dataSource]="dataSource2">
                                              <!-- Item Column -->
                                              <ng-container matColumnDef="item">
                                                <td mat-cell *matCellDef="let transaction"><span class="mob-header-text">Item Name:</span> {{transaction.item}} </td>
                                                <td mat-footer-cell *matFooterCellDef> Total  </td>
                                              </ng-container>
                                          
                                              <!-- Cost Column -->
                                              <ng-container matColumnDef="cost">
                                                <td mat-cell *matCellDef="let transaction"><span class="mob-header-text">Price:</span> <span [innerHTML]="currencyLogo!=null?currencyLogo:currencyAbri"></span> {{transaction.price}} </td>
                                                <td mat-footer-cell *matFooterCellDef class="table-footer">  <span [innerHTML]="currencyLogo!=null?currencyLogo:currencyAbri"></span>{{order?.TotalPrice+order?.tip}}</td>
                                              </ng-container>
                                          
                                              <tr mat-row *matRowDef="let row; columns: displayedColumnss;"></tr>
                                              <tr mat-footer-row class="nunito" *matFooterRowDef="displayedColumnss; sticky: true"></tr>
                                            </table>
                                        </div>
                                      </div>
                                     
                                
                                
                                  
                                  
                            </div>
                        </mat-expansion-panel>
                    </mat-accordion>
                </div>




            </mat-tab>
        </mat-tab-group>

    </div>
</div>

